import 'cropperjs/dist/cropper.css';
import 'mobx-react-lite/batchingForReactDom';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core';
import App from 'next/app';
import Head from 'next/head';

import '@/styles.scss';
import { Auth0Provider } from '@auth0/auth0-react';
import { getAnalyticsInstance } from '@/utils/analytics';
import { NavDrawerProvider } from '@/hooks/useNavDrawer';
import LiveAgentChat from '../components/LiveAgentChatWrapper';
import { StoresProvider } from '@/hooks/useStores';
import LaunchDarkly from '@/components/LaunchDarkly';
import MainLayout from '@/components/Layouts/Layout';
import muiTheme from '@/utils/styles/muiTheme';
import RouteListener from '@/components/RouteListener';
import SetupGlobalStyles from '@/utils/styles/setupGlobalStyles';
import theme from '@/utils/styles/theme';
import { protocol } from '../utils/config';

const { analytics } = getAnalyticsInstance();

class MyApp extends App {
  componentDidMount() {
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }

  render() {
    const { Component, pageProps } = this.props;
    const propsToPassToComponent = { ...pageProps, analytics };
    return (
      <Auth0Provider
        domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN}
        clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID}
        audience={process.env.NEXT_PUBLIC_AUTH0_AUDIENCE}
        redirectUri={process.env.NEXT_PUBLIC_AUTH0_CALLBACK_URL}
      >
        <StoresProvider>
          <ThemeProvider theme={theme}>
            <MuiThemeProvider theme={muiTheme}>
              <SnackbarProvider
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <NavDrawerProvider>
                  <MainLayout>
                    <LaunchDarkly>
                      <Head>
                        <title>Volusion</title>
                      </Head>
                      <RouteListener>
                        <Component {...propsToPassToComponent} />
                      </RouteListener>
                      <LiveAgentChat />
                    </LaunchDarkly>
                  </MainLayout>
                </NavDrawerProvider>
                <SetupGlobalStyles />
              </SnackbarProvider>
            </MuiThemeProvider>
          </ThemeProvider>
        </StoresProvider>
      </Auth0Provider>
    );
  }
}

export default MyApp;
